import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import withAuthorization from '../../hoc/withAuthorization';
import LargePaper from '../../components/Layout/LargePaper';
import stylesDefault from '../../constants/stylesDefault';
import { getUsers, getUsersForRenter } from '../../store/users/actions';
import UserTable from '../../components/Users/UserTable';
import { ROLE_ADMIN } from '../../constants/roles';

export const UsersPage = (props) => {
  const dispatch = useDispatch();
  const users = useSelector(state => state.users);
  const roles = useSelector(state => state.roles);
  const { authUser } = props;

  if (authUser && roles.content) {
    if (!users.content && !users.pending && !users.error) {
      if (roles.content[authUser.uid] && roles.content[authUser.uid] < ROLE_ADMIN) {
        dispatch(getUsersForRenter(authUser));
      } else {
        dispatch(getUsers());
      }
    }
  }

  return (
    <LargePaper>
      <h1 style={stylesDefault.title}>Clients</h1>
      <UserTable
        authUser={authUser}
        users={users.content}
        pending={users.pending}
      />
    </LargePaper>
  );
};

export default withAuthorization(authUser => !!authUser)(UsersPage);



// WEBPACK FOOTER //
// ./src/containers/UsersPage/UsersPage.jsx